import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { initializeAnalytics } from '../utils/analyticsManager';

const AnalyticsInitializer = ({ children }) => {
  const { accepted, analyticsEnabled, gtmEnabled } = useSelector((state) => state.cookieAcceptance);

  useEffect(() => {
    // Only initialize analytics if user has accepted cookies
    if (accepted) {
      initializeAnalytics(analyticsEnabled, gtmEnabled);
    } else {
      // Ensure analytics is disabled if user hasn't made a choice yet
      initializeAnalytics(false, false);
    }
  }, [accepted, analyticsEnabled, gtmEnabled]);

  return <>{children}</>;
};

export default AnalyticsInitializer;
